module.exports = __webpack_public_path__ + "5faf864fd2ea00469ea121ea9e856b38.fbx";